import styled from "styled-components";

export const StyledForm = styled.form`
  display: flex;
  flex-direction: row;
  gap: 4px;

  @media ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }
`;

export const InputField = styled.input`
  flex-grow: 1;
  padding: 12px;
  border: 1px solid
    ${({ $hasError }) =>
      $hasError ? "#f95959" : "rgba(29, 29, 29, 0.1)"};
  border-radius: 12px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 16px;
  line-height: 1.5em;
  color: rgba(29, 29, 29, 0.85);
  height: 48px;
  box-sizing: border-box;
  outline: none !important;
  box-shadow: none !important;

  &::placeholder {
    color: rgba(29, 29, 29, 0.5);
  }

  &:focus {
    border-color: ${({ $hasError }) =>
      $hasError ? "#f95959" : "rgba(29, 29, 29, 0.2)"};
  }

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
    height: 48px;
  }
`;

export const SubmitButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  isolation: isolate;
  background-color: ${({ $variant }) =>
    $variant === "primary" ? "rgb(29, 29, 29)" : "rgb(255, 96, 48)"};
  border-radius: 12px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #ffffff;
  width: max-content;
  position: relative;
  overflow: hidden;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  outline: none;
  border: none;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  /* Blur effect */
  &::before {
    content: "";
    position: absolute;

    height: ${({ $variant }) => ($variant === "primary" ? "55.57px" : "18px")};
    left: 8.8%;
    right: 8.81%;
    top: 38.26px;
    background-color: ${({ $variant }) =>
      $variant === "primary" ? "#fc714a" : "#ffab95"};
    opacity: 0.3;
    filter: blur(16px);
    border-radius: 59px;
    opacity: ${({ $variant }) => ($variant === "primary" ? "0.3" : "1")};
  }

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
    height: 48px;
    flex-shrink: 0;
  }

  &:hover {
    background: ${({ $variant, disabled }) =>
      disabled
        ? $variant === "primary"
          ? "rgb(29, 29, 29)"
          : "rgb(255, 96, 48)"
        : $variant === "primary"
        ? "linear-gradient(0deg, rgba(29, 29, 29, 0.85), rgba(29, 29, 29, 0.85)), #ffffff"
        : "linear-gradient(0deg, rgba(255, 96, 48, 0.85), rgba(255, 96, 48, 0.85)), #ffffff"};
  }
`;

export const ButtonText = styled.span`
  align-self: stretch;
  margin: auto 0;
`;

export const ButtonIcon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  width: 20px;
  align-self: stretch;
  flex-shrink: 0;
  margin: auto 0;
`;
